var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDocuments = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2814 1.00979H6.73728C5.00394 1.00312 3.58311 2.38479 3.54227 4.11729V13.0448C3.50394 14.8057 4.89978 16.2647 6.66061 16.3039C6.68644 16.3039 6.71144 16.3047 6.73728 16.3039H13.3948C15.1398 16.2331 16.5148 14.7915 16.5023 13.0448V5.40645L12.2814 1.00979Z",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 1V3.42416C12.0625 4.6075 13.0192 5.56667 14.2025 5.57H16.4983",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2814 1.00979H6.73728C5.00394 1.00312 3.58311 2.38479 3.54227 4.11729V13.0448C3.50394 14.8057 4.89978 16.2647 6.66061 16.3039C6.68644 16.3039 6.71144 16.3047 6.73728 16.3039H13.3948C15.1398 16.2331 16.5148 14.7915 16.5023 13.0448V5.40645L12.2814 1.00979Z",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.00002C1.76666 2.99335 1.04161 4.37502 1.00077 6.10752V15.035C0.962441 16.7959 2.35828 18.255 4.11911 18.2942C4.14494 18.2942 4.16994 18.295 4.19578 18.2942H10.8533C12.5983 18.2234 14.0125 18.2467 14 16.5",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2814 1.00979H6.73728C5.00394 1.00312 3.58311 2.38479 3.54227 4.11729V13.0448C3.50394 14.8057 4.89978 16.2647 6.66061 16.3039C6.68644 16.3039 6.71144 16.3047 6.73728 16.3039H13.3948C15.1398 16.2331 16.5148 14.7915 16.5023 13.0448V5.40645L12.2814 1.00979Z",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 1V3.42416C12.0625 4.6075 13.0192 5.56667 14.2025 5.57H16.4983",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9067 11.507H7.40674",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2024 8.38004H7.40576",
    stroke: "#EC6A4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDocuments, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/documents.78fd5a75.svg";
export { ForwardRef as ReactComponent };